import { apiGet } from './client';
import { ApiResponse } from '@tinyrewards/shared';
import { PortfolioItem } from './portfolio';

export interface PublicProfile {
    userID: string;
    displayName: string;
    bio: string | null;
    profileImage: string | null;
    shortName: string | null;
}

export interface PublicProfileData {
    profile: PublicProfile;
    badges: PortfolioItem[];
}

/** Fetch a user's public profile by short name or UserID. */
export function getPublicProfile(slug: string): Promise<ApiResponse<PublicProfileData>> {
    return apiGet<PublicProfileData>(`/api/public-profile/${encodeURIComponent(slug)}`);
}
